module.exports = __webpack_public_path__ + "static/media/review.36476d3c.png";